import Redio from './Redio.vue';

Redio.install = (Vue) => {
  Vue.component(Redio.name, Redio);
};

export default Redio;
